
<template>
    

    <div class="product-wrap d_f jc_sb">
        
        <div class="cate">

            <ul>
                <li v-for="(item) in navList" :key="item.id" @click="changeNav(item.id)" :class="item.id == navActive ?'active':''">
                    {{item.name}}
                </li>
            </ul>

        </div>

        <div class="product">
            <div v-if="list && list.length > 0" class="product-list d_f jc_sb">
                <showCard v-for="item in list" :key="item.id" :to='"/product/details?id="+item.id' :img='item.photoUrl' :title="item.productName"/>
            </div>
            <div v-else>
                <a-result status="500" title="暂时没有数据" sub-title="No data at present" />
            </div>
            <Pagetion @pageActive='pageActive' :defaultPage='page' v-if="list.length > 0" :pageSize='pagelength'/>
        </div>

        <div class="m_product">

            <a-dropdown class="drop">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    全部分类
                 <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                    <a-menu-item 
                        class="drop-item"
                        v-for="(item) in navList" 
                        :key="item.id" 
                        @click="changeNav(item.id)" 
                        :class="item.id == navActive ?'active':''">
                        <a href="javascript:;">{{item.name}}</a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>


            <scroller v-if="list && list.length > 0" class="scroll" 
                :on-infinite="infinite" 
                ref="prodScroller">
                <div class="scroll-wrap">
                    <showCard v-for="item in list" :key="item.id" :to='"/product/details?id="+item.id' :img='item.photoUrl' :title="item.productName" size='min'/>
                    <!-- <div class="fill">填充物</div> -->
                </div>
            </scroller>
            <div v-else>
                <a-result status="500" title="暂时没有数据" sub-title="No data at present" />
            </div>


        </div>



    </div>    



</template>

<script>
import index from './index'
import Pagetion from '../../components/Pagetion/index.vue';
import showCard from '../../components/show-card/index'
export default {
    ...index,
    components : {
        Pagetion,
        showCard
    },
}
</script>

<style lang="scss" scoped>
    .product-wrap{
        width: 1200px;
        margin: 80px auto;
        .cate{
            width: 300px;
            // height: 82px;
            ul>li{
                line-height: 82px;
                padding-left: 30px;
                border-left: 10px solid transparent;
                font-size: 20px;
                cursor: pointer;
            }
            .active{
                border-left: 10px solid #0067cc;
                background-color: rgba(0, 103, 204, .1);
            }
        }
        .product{
            width: 865px;
            .product-list{
                width: 100%;
                flex-wrap: wrap;
            }
        }
    }
    .m_product{
        display: none;
    }
    @media screen and (max-width: 750px){
        .cate,.product{
            display: none;
        }
        .product-wrap{
            width: 100%;
            height: calc(100vh - 13.298vw);
            background-color: #F8F8F8;
            margin: 0;
        }

        .m_product{
            width: 100%;
            display: block;
            background-color: #F8F8F8;
            .drop{
                display: block;
                width: 100%;
                line-height: 12.234vw;
                text-align: center;
                font-size: 3.989vw;
            }
            .scroll{
                top: 26.596vw;
                height: calc(100vh - 50.596vw) !important;
                background-color: #F8F8F8;
                .scroll-wrap{
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding: 0 5.319vw;
                    a{
                        margin-bottom: 2.66vw;
                    }
                    .fill{
                        height: 26.596vw;
                        width: 100%;
                        opacity: 0;
                    }
                }
            }
        }
        .active{
            background-color: #e6f7ff !important;
        }
        .drop-item{
            display: block;
            font-size: 3.989vw;
            line-height: 12.234vw;
            text-align: center;
            background-color: #F8F8F8;
        }
    }


</style>